export default __webpack_public_path__ + "static/media/Q32018.af23637f.PDF";